import React, { Component } from 'react';
import { Spin, Button } from 'antd';
import _notification from 'modules/notification';
import _InterviewScheduleService from 'modules/InterviewScheduleService';
import moment from 'moment';

// Phase B (Interview Scheduling).
//
// Candidate Login artifact — reached from the dashboard, never a public/anonymous surface. Shows only
// what the actual data model supports (Post, Roll Number, Interview Date, Interview Time, Venue if an
// admin has set one) for a Released schedule matching the candidate's own record. PostId/RollNumber/
// ApplicationId are never chosen or supplied by this component — the backend derives everything from
// the authenticated session. Deliberately independent of the existing InterviewCallLetter.jsx screen
// (Phase C territory — not touched here).
class InterviewSchedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            schedule: null
        };
    }

    componentDidMount() {
        this.loadSchedule();
    }

    loadSchedule = async () => {
        this.setState({ loading: true });
        try {
            const response = await _InterviewScheduleService.getForCandidate();
            this.setState({ schedule: (response.status === 200 && response.data) || null, loading: false });
        } catch (e) {
            this.setState({ loading: false });
            _notification.showMessage('error', 'Something went wrong. Please try again.');
        }
    }

    render() {
        const { loading, schedule } = this.state;

        if (loading) return <div role="status" aria-live="polite"><Spin size="large" /></div>;

        return (
            <div className="candidate-result ch-container gl-bxbr analysisWrap p-4 mt-4">
                <h4 className="ch-heading4 mb-4 text-center">Interview Schedule</h4>

                {!schedule && (
                    <div className="candidateform-cover pt-3 pr-3 pl-3 pb-3 candidate-result-wrap text-center">
                        <p className="mb-0">Your interview schedule has not been released yet. Please check back later.</p>
                    </div>
                )}

                {schedule && (
                    <div className="candidateform-cover pt-3 pr-3 pl-3 pb-3 candidate-result-wrap">
                        <div className="row">
                            <div className="mb-2 col-sm-6 d-flex">
                                <label className="font-weight-bold">Post:&nbsp;</label>
                                <label>{schedule.PostName}</label>
                            </div>
                            <div className="mb-2 col-sm-6 d-flex">
                                <label className="font-weight-bold">Roll Number:&nbsp;</label>
                                <label>{schedule.RollNumber}</label>
                            </div>
                            <div className="mb-2 col-sm-6 d-flex">
                                <label className="font-weight-bold">Interview Date:&nbsp;</label>
                                <label>{moment(schedule.InterviewDate).format('DD-MMM-YYYY')}</label>
                            </div>
                            <div className="mb-2 col-sm-6 d-flex">
                                <label className="font-weight-bold">Interview Time:&nbsp;</label>
                                <label>{schedule.InterviewTime}</label>
                            </div>
                            {schedule.Venue && (
                                <div className="mb-2 col-sm-12 d-flex">
                                    <label className="font-weight-bold">Venue:&nbsp;</label>
                                    <label>{schedule.Venue}</label>
                                </div>
                            )}
                        </div>

                        {/* Phase C (Interview Call Letter) — a separate, explicit release decision from the
                            schedule above; only shown once the admin has released the Call Letter itself. */}
                        {schedule.IsCallLetterReleased && (
                            <div className="mt-3 text-center">
                                <Button className="button-global button-primary autoHeight autoWidth" onClick={() => this.props.onTabOrderChange(9)}>
                                    View / Download Interview Call Letter
                                </Button>
                            </div>
                        )}
                    </div>
                )}

                <div className="row mt-4 footer-buttons">
                    <div className="col-12">
                        <div className="form-action d-flex justify-content-center">
                            <Button className="button-global button-border autoHeight ml-4 autoWidth" onClick={() => this.props.onTabOrderChange(-1)}>
                                Back to Dashboard
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InterviewSchedule;
